import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DokumentyKlientaComponent } from './dokumenty-klienta/dokumenty-klienta.component';
import { KpirComponent } from './ewidencja/kpir/kpir.component';
import { RyczaltComponent } from './ewidencja/ryczalt/ryczalt.component';
import { SprzedazComponent } from './ewidencja/sprzedaz/sprzedaz.component';
import { ZakupComponent } from './ewidencja/zakup/zakup.component';
import { HomeDgComponent } from './home-dg/home-dg.component';
import { HomeKhComponent } from './home-kh/home-kh.component';
import { KontaktComponent } from './kontakt/kontakt.component';
import { KontoComponent } from './konto/konto.component';
import { MaterialyDlaKlientaComponent } from './materialy-dla-klienta/materialy-dla-klienta.component';
import { PagesComponent } from './pages.component';
import { PlatnosciComponent } from './platnosci/platnosci.component';
import { PrzychodyKosztyComponent } from './przychody-koszty/przychody-koszty.component';
import { SaldeoComponent } from './saldeo/saldeo.component';
import { SrodkiTrwaleComponent } from './srodki-trwale/srodki-trwale.component';
import { WynagrodzeniaComponent } from './wynagrodzenia/wynagrodzenia.component';
import { ZusPodatkiComponent } from './zus/zus-podatki.component';
import { HomeRedirectGuard } from '../@core/guards/home-redirect.guard';


const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'kontakt',
      component: KontaktComponent,
    },
    {
      path: 'konto',
      component: KontoComponent,
    },
    {
      path: 'zakup',
      component: ZakupComponent,
    },
    {
      path: 'kpir',
      component: KpirComponent,
    },
    {
      path: 'platnosci',
      component: PlatnosciComponent,
    },
    {
      path: 'raporty',
      component: DokumentyKlientaComponent,
    },
    {
      path: 'sprzedaz',
      component: SprzedazComponent,
    },
    {
      path: 'przychody-koszty',
      component: PrzychodyKosztyComponent,
    },
    {
      path: 'saldeo',
      component: SaldeoComponent,
    },
    {
      path: 'srodki-trwale',
      component: SrodkiTrwaleComponent,
    },
    {
      path: 'wynagrodzenia',
      component: WynagrodzeniaComponent,
    },
    {
      path: 'zus-podatki',
      component: ZusPodatkiComponent,
    },
    {
      path: 'materialy',
      component: MaterialyDlaKlientaComponent,
    },
    {
      path: 'ryczalt',
      component: RyczaltComponent,
    },
    {
      path: 'home-dg',
      component: HomeDgComponent,
    },
    {
      path: 'home-kh',
      component: HomeKhComponent,
    },
    {
      path: '',
      canActivate: [HomeRedirectGuard],
      children: []
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
